export const sugartownNFTs = [
               {
            id: 'Sugartown Oras-6909',
            name: 'Sugartown Oras #6909',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6909.png',
            price: '0.45 ETH'
        },
        {
            id: 'Sugartown Oras-6907',
            name: 'Sugartown Oras #6907',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6907.png',
            price: '0.82 ETH'
        },
        {
            id: 'Sugartown Oras-6908',
            name: 'Sugartown Oras #6908',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6908.png',
            price: '0.31 ETH'
        },
        {
            id: 'Sugartown Oras-6906',
            name: 'Sugartown Oras #6906',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6906.png',
            price: '0.56 ETH'
        },
        {
            id: 'Sugartown Oras-6902',
            name: 'Sugartown Oras #6902',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6902.png',
            price: '0.93 ETH'
        },
        {
            id: 'Sugartown Oras-6904',
            name: 'Sugartown Oras #6904',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6904.png',
            price: '0.25 ETH'
        },
        {
            id: 'Sugartown Oras-6905',
            name: 'Sugartown Oras #6905',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6905.png',
            price: '0.67 ETH'
        },
        {
            id: 'Sugartown Oras-6903',
            name: 'Sugartown Oras #6903',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6903.png',
            price: '0.42 ETH'
        },
        {
            id: 'Sugartown Oras-6901',
            name: 'Sugartown Oras #6901',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6901.png',
            price: '0.88 ETH'
        },
        {
            id: 'Sugartown Oras-6900',
            name: 'Sugartown Oras #6900',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6900.png',
            price: '0.35 ETH'
        },
        {
            id: 'Sugartown Oras-6899',
            name: 'Sugartown Oras #6899',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6899.png',
            price: '0.71 ETH'
        },
        {
            id: 'Sugartown Oras-6898',
            name: 'Sugartown Oras #6898',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6898.png',
            price: '0.29 ETH'
        },
        {
            id: 'Sugartown Oras-6896',
            name: 'Sugartown Oras #6896',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6896.png',
            price: '0.63 ETH'
        },
        {
            id: 'Sugartown Oras-6895',
            name: 'Sugartown Oras #6895',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6895.png',
            price: '0.48 ETH'
        },
        {
            id: 'Sugartown Oras-6897',
            name: 'Sugartown Oras #6897',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6897.png',
            price: '0.95 ETH'
        },
        {
            id: 'Sugartown Oras-6894',
            name: 'Sugartown Oras #6894',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6894.png',
            price: '0.22 ETH'
        },
        {
            id: 'Sugartown Oras-6892',
            name: 'Sugartown Oras #6892',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6892.png',
            price: '0.75 ETH'
        },
        {
            id: 'Sugartown Oras-6893',
            name: 'Sugartown Oras #6893',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6893.png',
            price: '0.39 ETH'
        },
        {
            id: 'Sugartown Oras-6891',
            name: 'Sugartown Oras #6891',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6891.png',
            price: '0.84 ETH'
        },
        {
            id: 'Sugartown Oras-6890',
            name: 'Sugartown Oras #6890',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6890.png',
            price: '0.27 ETH'
        },
        {
            id: 'Sugartown Oras-6889',
            name: 'Sugartown Oras #6889',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6889.png',
            price: '0.69 ETH'
        },
        {
            id: 'Sugartown Oras-6888',
            name: 'Sugartown Oras #6888',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6888.png',
            price: '0.44 ETH'
        },
        {
            id: 'Sugartown Oras-6887',
            name: 'Sugartown Oras #6887',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6887.png',
            price: '0.91 ETH'
        },
        {
            id: 'Sugartown Oras-6886',
            name: 'Sugartown Oras #6886',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6886.png',
            price: '0.33 ETH'
        },
        {
            id: 'Sugartown Oras-6883',
            name: 'Sugartown Oras #6883',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6883.png',
            price: '0.77 ETH'
        },
        {
            id: 'Sugartown Oras-6882',
            name: 'Sugartown Oras #6882',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6882.png',
            price: '0.51 ETH'
        },
        {
            id: 'Sugartown Oras-6881',
            name: 'Sugartown Oras #6881',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6881.png',
            price: '0.96 ETH'
        },
        {
            id: 'Sugartown Oras-6880',
            name: 'Sugartown Oras #6880',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6880.png',
            price: '0.19 ETH'
        },
        {
            id: 'Sugartown Oras-6879',
            name: 'Sugartown Oras #6879',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6879.png',
            price: '0.73 ETH'
        },
        {
            id: 'Sugartown Oras-6877',
            name: 'Sugartown Oras #6877',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6877.png',
            price: '0.37 ETH'
        },
        {
            id: 'Sugartown Oras-6876',
            name: 'Sugartown Oras #6876',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6876.png',
            price: '0.86 ETH'
        },
        {
            id: 'Sugartown Oras-6875',
            name: 'Sugartown Oras #6875',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6875.png',
            price: '0.24 ETH'
        },
        {
            id: 'Sugartown Oras-6874',
            name: 'Sugartown Oras #6874',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6874.png',
            price: '0.65 ETH'
        },
        {
            id: 'Sugartown Oras-6873',
            name: 'Sugartown Oras #6873',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6873.png',
            price: '0.41 ETH'
        },
        {
            id: 'Sugartown Oras-6872',
            name: 'Sugartown Oras #6872',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6872.png',
            price: '0.89 ETH'
        },
        {
            id: 'Sugartown Oras-6869',
            name: 'Sugartown Oras #6869',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6869.png',
            price: '0.32 ETH'
        },
        {
            id: 'Sugartown Oras-6871',
            name: 'Sugartown Oras #6871',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6871.png',
            price: '0.79 ETH'
        },
        {
            id: 'Sugartown Oras-6870',
            name: 'Sugartown Oras #6870',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6870.png',
            price: '0.47 ETH'
        },
        {
            id: 'Sugartown Oras-6868',
            name: 'Sugartown Oras #6868',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6868.png',
            price: '0.94 ETH'
        },
        {
            id: 'Sugartown Oras-6867',
            name: 'Sugartown Oras #6867',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6867.png',
            price: '0.17 ETH'
        },
        {
            id: 'Sugartown Oras-6866',
            name: 'Sugartown Oras #6866',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6866.png',
            price: '0.72 ETH'
        },
        {
            id: 'Sugartown Oras-6864',
            name: 'Sugartown Oras #6864',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6864.png',
            price: '0.36 ETH'
        },
        {
            id: 'Sugartown Oras-6863',
            name: 'Sugartown Oras #6863',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6863.png',
            price: '0.85 ETH'
        },
        {
            id: 'Sugartown Oras-6860',
            name: 'Sugartown Oras #6860',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6860.png',
            price: '0.23 ETH'
        },
        {
            id: 'Sugartown Oras-6861',
            name: 'Sugartown Oras #6861',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6861.png',
            price: '0.68 ETH'
        },
        {
            id: 'Sugartown Oras-6862',
            name: 'Sugartown Oras #6862',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6862.png',
            price: '0.43 ETH'
        },
        {
            id: 'Sugartown Oras-6856',
            name: 'Sugartown Oras #6856',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6856.png',
            price: '0.92 ETH'
        },
        {
            id: 'Sugartown Oras-6858',
            name: 'Sugartown Oras #6858',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6858.png',
            price: '0.28 ETH'
        },
        {
            id: 'Sugartown Oras-6859',
            name: 'Sugartown Oras #6859',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6859.png',
            price: '0.76 ETH'
        },
        {
            id: 'Sugartown Oras-6854',
            name: 'Sugartown Oras #6854',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6854.png',
            price: '0.49 ETH'
        },
        {
            id: 'Sugartown Oras-6855',
            name: 'Sugartown Oras #6855',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6855.png',
            price: '0.97 ETH'
        },
        {
            id: 'Sugartown Oras-6853',
            name: 'Sugartown Oras #6853',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6853.png',
            price: '0.15 ETH'
        },
            {
            id: 'Sugartown Oras-6852',
            name: 'Sugartown Oras #6852',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6852.png',
            price: '0.74 ETH'
        },
        {
            id: 'Sugartown Oras-6850',
            name: 'Sugartown Oras #6850',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6850.png',
            price: '0.38 ETH'
        },
        {
            id: 'Sugartown Oras-6851',
            name: 'Sugartown Oras #6851',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6851.png',
            price: '0.87 ETH'
        },
        {
            id: 'Sugartown Oras-6849',
            name: 'Sugartown Oras #6849',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6849.png',
            price: '0.26 ETH'
        },
        {
            id: 'Sugartown Oras-6848',
            name: 'Sugartown Oras #6848',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6848.png',
            price: '0.66 ETH'
        },
        {
            id: 'Sugartown Oras-6847',
            name: 'Sugartown Oras #6847',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6847.png',
            price: '0.42 ETH'
        },
        {
            id: 'Sugartown Oras-6846',
            name: 'Sugartown Oras #6846',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6846.png',
            price: '0.90 ETH'
        },
        {
            id: 'Sugartown Oras-6865',
            name: 'Sugartown Oras #6865',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6865.png',
            price: '0.33 ETH'
        },
        {
            id: 'Sugartown Oras-6878',
            name: 'Sugartown Oras #6878',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6878.png',
            price: '0.78 ETH'
        },
        {
            id: 'Sugartown Oras-6857',
            name: 'Sugartown Oras #6857',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6857.png',
            price: '0.52 ETH'
        },
        {
            id: 'Sugartown Oras-6885',
            name: 'Sugartown Oras #6885',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6885.png',
            price: '0.95 ETH'
        },
        {
            id: 'Sugartown Oras-6884',
            name: 'Sugartown Oras #6884',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6884.png',
            price: '0.20 ETH'
        },
        {
            id: 'Sugartown Oras-6845',
            name: 'Sugartown Oras #6845',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6845.png',
            price: '0.71 ETH'
        },
        {
            id: 'Sugartown Oras-6843',
            name: 'Sugartown Oras #6843',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6843.png',
            price: '0.36 ETH'
        },
        {
            id: 'Sugartown Oras-6844',
            name: 'Sugartown Oras #6844',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6844.png',
            price: '0.83 ETH'
        },
        {
            id: 'Sugartown Oras-6842',
            name: 'Sugartown Oras #6842',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6842.png',
            price: '0.25 ETH'
        },
        {
            id: 'Sugartown Oras-6840',
            name: 'Sugartown Oras #6840',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6840.png',
            price: '0.64 ETH'
        },
        {
            id: 'Sugartown Oras-6839',
            name: 'Sugartown Oras #6839',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6839.png',
            price: '0.41 ETH'
        },
        {
            id: 'Sugartown Oras-6838',
            name: 'Sugartown Oras #6838',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6838.png',
            price: '0.88 ETH'
        },
        {
            id: 'Sugartown Oras-6837',
            name: 'Sugartown Oras #6837',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6837.png',
            price: '0.31 ETH'
        },
        {
            id: 'Sugartown Oras-6836',
            name: 'Sugartown Oras #6836',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6836.png',
            price: '0.76 ETH'
        },
        {
            id: 'Sugartown Oras-6835',
            name: 'Sugartown Oras #6835',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6835.png',
            price: '0.50 ETH'
        },
        {
            id: 'Sugartown Oras-6834',
            name: 'Sugartown Oras #6834',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6834.png',
            price: '0.93 ETH'
        },
        {
            id: 'Sugartown Oras-6833',
            name: 'Sugartown Oras #6833',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6833.png',
            price: '0.18 ETH'
        },
        {
            id: 'Sugartown Oras-6832',
            name: 'Sugartown Oras #6832',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6832.png',
            price: '0.69 ETH'
        },
        {
            id: 'Sugartown Oras-6831',
            name: 'Sugartown Oras #6831',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6831.png',
            price: '0.35 ETH'
        },
        {
            id: 'Sugartown Oras-6830',
            name: 'Sugartown Oras #6830',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6830.png',
            price: '0.81 ETH'
        },
        {
            id: 'Sugartown Oras-6828',
            name: 'Sugartown Oras #6828',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6828.png',
            price: '0.24 ETH'
        },
        {
            id: 'Sugartown Oras-6829',
            name: 'Sugartown Oras #6829',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6829.png',
            price: '0.62 ETH'
        },
        {
            id: 'Sugartown Oras-6827',
            name: 'Sugartown Oras #6827',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6827.png',
            price: '0.40 ETH'
        },
        {
            id: 'Sugartown Oras-6825',
            name: 'Sugartown Oras #6825',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6825.png',
            price: '0.86 ETH'
        },
        {
            id: 'Sugartown Oras-6824',
            name: 'Sugartown Oras #6824',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6824.png',
            price: '0.29 ETH'
        },
        {
            id: 'Sugartown Oras-6822',
            name: 'Sugartown Oras #6822',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6822.png',
            price: '0.73 ETH'
        },
        {
            id: 'Sugartown Oras-6821',
            name: 'Sugartown Oras #6821',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6821.png',
            price: '0.48 ETH'
        },
        {
            id: 'Sugartown Oras-6820',
            name: 'Sugartown Oras #6820',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6820.png',
            price: '0.91 ETH'
        },
        {
            id: 'Sugartown Oras-6818',
            name: 'Sugartown Oras #6818',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6818.png',
            price: '0.16 ETH'
        },
        {
            id: 'Sugartown Oras-6817',
            name: 'Sugartown Oras #6817',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6817.png',
            price: '0.67 ETH'
        },
        {
            id: 'Sugartown Oras-6816',
            name: 'Sugartown Oras #6816',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6816.png',
            price: '0.34 ETH'
        },
        {
            id: 'Sugartown Oras-6815',
            name: 'Sugartown Oras #6815',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6815.png',
            price: '0.79 ETH'
        },
        {
            id: 'Sugartown Oras-6813',
            name: 'Sugartown Oras #6813',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6813.png',
            price: '0.23 ETH'
        },
        {
            id: 'Sugartown Oras-6812',
            name: 'Sugartown Oras #6812',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6812.png',
            price: '0.61 ETH'
        },
        {
            id: 'Sugartown Oras-6826',
            name: 'Sugartown Oras #6826',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6826.png',
            price: '0.39 ETH'
        },
        {
            id: 'Sugartown Oras-6814',
            name: 'Sugartown Oras #6814',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6814.png',
            price: '0.85 ETH'
        },
        {
            id: 'Sugartown Oras-6841',
            name: 'Sugartown Oras #6841',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6841.png',
            price: '0.28 ETH'
        },
        {
            id: 'Sugartown Oras-6823',
            name: 'Sugartown Oras #6823',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6823.png',
            price: '0.72 ETH'
        },
        {
            id: 'Sugartown Oras-6819',
            name: 'Sugartown Oras #6819',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6819.png',
            price: '0.47 ETH'
        },
        {
            id: 'Sugartown Oras-6811',
            name: 'Sugartown Oras #6811',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6811.png',
            price: '0.94 ETH'
        },
        {
            id: 'Sugartown Oras-6809',
            name: 'Sugartown Oras #6809',
            image: 'https://nfts.visitsugartown.com/nfts/oras/6809.png',
            price: '0.13 ETH'
        }
    
];